<template>
    <div class="container">
        <canvas ref="canvas" width="900" height="500"></canvas>
    </div>
</template>
<script>

    //import VueCharts from 'vue-chartjs'
    import { Line, mixins } from 'vue-chartjs'
    import chroma from "chroma-js";


    export default {
        name: 'Widget',
        extends: Line,
        props: ['dataset','labels','options','chartData'],
        mixins: [mixins.reactiveProp],
        data () {
            return {
                colors: [
                    //'rgba(237, 150, 68, #)',
                    //'rgba(241, 84, 113, #)',
                    'rgba(18, 183, 151, #)',
                    'rgba(18, 161, 253, #)',
                    'rgba(187, 1, 240, #)',
                    'rgba(1, 240, 170, #)',
                    'rgba(247, 0, 65, #)',
                    'rgba(1, 170, 240, #)',
                    'rgba(1, 240, 170, #)'
                ]
            }
        },
        mounted: function(){

            this.renderViewChart()

        },
        methods: {
          renderColors: function(count)
          {
            let colors = window.chartColors(count);

            let backgroundColors = [];
            let hoverBackgroundColors = [];

            for(let i=0 ; i<colors.length ; i++)
            {

              var c = 'rgba(' + chroma(colors[i]).rgb().join(',') + ', #)';

              var gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 400, 0, 100)
              gradient.addColorStop(0, c.replace('#', 0.2))
              gradient.addColorStop(1, c.replace('#', 0.05))

              backgroundColors.push(gradient);
              hoverBackgroundColors.push(colors[i]);
            }

            return {backgroundColors:backgroundColors, hoverBackgroundColors:hoverBackgroundColors}
          },
          renderViewChart: function()
          {

            let borderWidth = 2;
            let transparentBackgroundTop = 0.8;
            let transparentBackgroundBottom = 0.3;
            if( this.options.__custom && this.options.__custom.borderWidth !== undefined ){ borderWidth = this.options.__custom.borderWidth; }
            if( this.options.__custom && this.options.__custom.transparentBackgroundTop !== undefined ){ transparentBackgroundTop = this.options.__custom.transparentBackgroundTop; }
            if( this.options.__custom && this.options.__custom.transparentBackgroundBottom !== undefined ){ transparentBackgroundBottom = this.options.__custom.transparentBackgroundBottom; }


            let count = Object.keys(this.dataset).length;
            let backgroundColor = this.renderColors(count, transparentBackgroundTop, transparentBackgroundBottom).backgroundColors;
            let hoverBackgroundColor = this.renderColors(count, transparentBackgroundTop, transparentBackgroundBottom).hoverBackgroundColors;

            var datasets = [];
            let colorIndex = 0
            for(var index in this.dataset) {
              let element = this.dataset[index];

              let bgColor = backgroundColor[colorIndex]
              if( element.backgroundColor && element.backgroundColor != "transparent" )
              {
                let elementColor = 'rgba(' + chroma(element.backgroundColor).rgb().join(',') + ', #)';
                let elementGradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 400, 0, 100)
                elementGradient.addColorStop(0, elementColor.replace('#', transparentBackgroundTop))
                elementGradient.addColorStop(1, elementColor.replace('#', transparentBackgroundBottom))
                bgColor = elementGradient
              }

              let bgColorHover = hoverBackgroundColor[colorIndex]
              if( element.backgroundColor && element.backgroundColor != "transparent" )
              {
                let elementColor = 'rgba(' + chroma(element.backgroundColor).rgb().join(',') + ', #)';
                let elementGradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 400, 0, 100)
                elementGradient.addColorStop(0, elementColor.replace('#', transparentBackgroundTop))
                elementGradient.addColorStop(1, elementColor.replace('#', transparentBackgroundBottom))
                bgColorHover = elementGradient
              }

              let borderColor = element.borderColor ? 'rgba(' + chroma(element.borderColor).rgb().join(',') + ', 1)' : bgColorHover;

              let data = element
              data.label = element.name ? element.name : element.label
              data.backgroundColor = element.backgroundColor || bgColor || 'transparent'
              data.data = element.data
              data.borderColor = borderColor
              data.pointBorderColor = '#ffffff'
              data.pointBackgroundColor = borderColor
              data.pointHoverBorderColor = borderColor
              data.pointHoverRadius = 3
              data.pointHoverBorderWidth = 2
              data.pointRadius = 3
              data.pointBorderWidth = (element.borderWidth || borderWidth) - 1
              data.borderWidth = element.borderWidth || borderWidth || 2

              datasets.push(data);

              colorIndex ++

            };


            this.renderChart({
              labels: this.labels,
              responsive: true,
              maintainAspectRatio: true,
              datasets: datasets
            }, this.options)
          }
        },
        watch: {
            dataset () {
                this.renderViewChart()
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/chart/Spline.vue